
import BaseSection from "@/components/base/BaseSection.vue";
import Passenger from "@/components/bookingflow/steps/passengerdetails/Passenger.vue";
import { PassengerTypeEnum, CustomerType } from "@/models/enums";
import { useBookingStore } from "@/store/booking";
import { useUserStore } from "@/store/user";
import { defineComponent } from "vue";
import { computed } from "vue";

	export default defineComponent({
		components: {
            BaseSection,
            Passenger
		},
        setup() {
			const bookingStore = useBookingStore();
			const userStore = useUserStore();
			const user = userStore.getUser;
			const isTravelClub = user.customerType === CustomerType.Travelclub;
            const passengers = computed(() => {
                        return bookingStore
                                .getBooking
                                .outward
                                .passengers
                                .filter(p => p.type !== PassengerTypeEnum.Dog);
                    });

			return { passengers, isTravelClub };
        }
	});
